import { render, staticRenderFns } from "./ehc-form-image-upload.vue?vue&type=template&id=3dc85326"
import script from "./ehc-form-image-upload.vue?vue&type=script&lang=js"
export * from "./ehc-form-image-upload.vue?vue&type=script&lang=js"
import style0 from "./ehc-form-image-upload.vue?vue&type=style&index=0&id=3dc85326&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports